import { Component, OnInit, Input } from '@angular/core';
import { BaseComponent } from '@tytapp/common';
import { Talent } from '@tytapp/models';

@Component({
  selector: 'app-hosts',
  templateUrl: './hosts.component.html',
  styleUrls: ['./hosts.component.scss']
})
export class HostsComponent extends BaseComponent {

  constructor(
  ) {
    super();
  }

  @Input()
  hosts : Talent[];

}
